import { render, staticRenderFns } from "./VenueCard.vue?vue&type=template&id=6dec9e76&scoped=true"
import script from "./VenueCard.vue?vue&type=script&lang=ts"
export * from "./VenueCard.vue?vue&type=script&lang=ts"
import style0 from "./VenueCard.vue?vue&type=style&index=0&id=6dec9e76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dec9e76",
  null
  
)

export default component.exports